export const formatMissingData = (strValue) => {
    if (!strValue?.toString().trim()) {
        return "-";
    }
    return strValue.toString();
}

export const formatExtraShareTableData = (value) => {
    const formattedMissingData = formatMissingData(value)
    if (formattedMissingData === "0")
        return "-"
    return formattedMissingData
}

export const formatCsvMissingData = (strValue) => {
    return `"=""${formatMissingData(strValue)}"""`;
}

export const formatNumberWithNull = (number) => {
    if (!number) {
        return 0;
    }
    return number;
}
